import React, { useEffect, useState } from 'react';
import avatar from '../../../assets/images/user-avatar.png';
import moment from 'moment';
import { UpdateWithdrawalStatusForm } from '../../../components/forms/Forms';
import { FaChevronLeft } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { PageSpinner } from '../../../components/spinner/Spinner';
import { config } from '../../../Constants';

const OnlineServiceWithdrawal = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const baseURL = config.baseURL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/withdrawals/online-service/admin/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(data);
        setData(data);
      } catch (error) {}
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const {
    userName,
    amount,
    status,
    ref,
    createdAt,
    _id,
    email,
    title,
    surname,
    firstName,
    occupation,
    clientNumber,
    investmentNumber,
    productName,
    bankName,
    accountNumber,
    branchName,
    accountType,
    accountHolderName,
    branchCode,
    withdrawalType,
    withdrawalReason,
  } = data;

  return (
    <main className='content online-service-withdrawal-page'>
      <div className='title-btn'>
        <Link to='/dashboard/online-service-withdrawals'>
          <FaChevronLeft />
        </Link>
        <h1 className='title'>Online Service Withdrawal</h1>
      </div>

      {data ? (
        <div className='blocks-cont'>
          <div className='brief-block'>
            <div className='img'>
              <img src={avatar} alt='' />
            </div>
            <h2>{userName}</h2>
            <h4>{email}</h4>
          </div>

          <div className='grid'>
            {/* personal details */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Personal Details</h2>
              </div>
              <hr />

              <form>
                {/* title & name */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='title'>Title</label>
                    <input type='text' value={title} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='fullName'>Full Name</label>
                    <input type='text' value={`${firstName} ${surname}`} disabled />
                  </div>
                </div>

                {/* occupation & client number */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='occupation'>Occupation</label>
                    <input type='text' value={occupation} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='clientNumber'>Client Number</label>
                    <input type='text' value={clientNumber} disabled />
                  </div>
                </div>

                {/* investment number & product name */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='investmentNumber'>Investment Number</label>
                    <input type='text' value={investmentNumber} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='productName'>Product Name</label>
                    <input type='text' value={productName} disabled />
                  </div>
                </div>
              </form>
            </div>

            {/* bank details */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Bank Details</h2>
              </div>
              <hr />

              <form>
                {/* bank name & account number */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='bankName'>Bank Name</label>
                    <input type='text' value={bankName} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='accountNumber'>Account Number</label>
                    <input type='text' value={accountNumber} disabled />
                  </div>
                </div>

                {/* branch name & branch code */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='branchName'>Branch Name</label>
                    <input type='text' value={branchName} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='branchCode'>Branch Code</label>
                    <input type='text' value={branchCode} disabled />
                  </div>
                </div>

                {/* account type & account holder */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='accountType'>Account Type</label>
                    <input type='text' value={accountType} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='accountHolderName'>Account Holder Name</label>
                    <input type='text' value={accountHolderName} disabled />
                  </div>
                </div>
              </form>
            </div>

            {/* withdrawal details */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Withdrawal Details</h2>
              </div>
              <hr />

              <form>
                {/* amount & withdrawal type */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='amount'>Withdrawal Amount</label>
                    <input type='text' value={`$${amount}`} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='withdrawalType'>Withdrawal Type</label>
                    <input type='text' value={withdrawalType} disabled />
                  </div>
                </div>

                {/* withdrawal reason */}
                <div className='form-control'>
                  <label htmlFor='withdrawalReason'>Withdrawal Reason</label>
                  <textarea value={withdrawalReason} disabled rows='4' />
                </div>

                {/* transaction date & reference  */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='createdAt'>Transaction Date</label>
                    <input
                      type='text'
                      value={moment(createdAt).format(`LLL`)}
                      disabled
                    />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='ref'>Transaction Ref.</label>
                    <input type='text' value={ref} disabled />
                  </div>
                </div>
              </form>
            </div>

            {/* transaction status */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Transaction Status</h2>
                <h4 className='sub-title'>Update Status</h4>
              </div>
              <hr />
              <UpdateWithdrawalStatusForm 
                status={status} 
                withdrawalId={_id} 
                isOnlineService={true}
              />
            </div>
          </div>
        </div>
      ) : (
        <PageSpinner />
      )}
    </main>
  );
};

export default OnlineServiceWithdrawal;